// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__XEG2o","BoxImage":"Box_BoxImage__2wDzC","BoxText":"Box_BoxText__sdmua","MainHeading":"Box_MainHeading__14a0H","SubHeading":"Box_SubHeading__2BckG"};